<template>
  <main>
    <PageIntro v-if="appLogin === false"
      :heading="'Register for an <span>' +configStrings.productName + '</span> account'"
      :body="'<p>Enter your details below to create your ' +configStrings.productName + ' account.</p><p>Your Hull City Hub account will allow you seamless access to Ticketing, Tigers Plus, Tiger Leisure and the Official App. This is a one-time registration required with your email.</p>'" />
    <PageIntro v-else
      :heading="'Register for an <span>' +configStrings.productName + ' account</span>'"
      :body="''" />
    <RegistrationFull />
    <FooterShout v-if="appLogin === false" :type="'signin'"/>
  </main>
</template>

<script>
  import RegistrationFull from '@/components/RegistrationFull'
  import PageIntro from '@/components/PageIntro'
  import FooterShout from '@/components/FooterShout'

  export default {
    components: {
      RegistrationFull,
      PageIntro,
      FooterShout
    },
    data() {
      return {
        appLogin: false
      }
    },
    mounted () {
      // if they are coming from the app specific login URL adapt the page accordingly
      if(this.$router.currentRoute.name === 'app-register'){
        this.appLogin = true
      }
    },
  }
</script>
